@if (document(); as document) {
  <div>
    <mat-toolbar>
      <!-- Left side controls -->
      <button mat-icon-button (click)="onClickCloseView()">
        <mat-icon>manage_search</mat-icon>
      </button>
      <span class="spacer"></span>
      <!-- Middle controls -->
      <button
        mat-icon-button
        [matTooltip]="'PREVIOUS' | transloco"
        [disabled]="!canNavigateToPreviousDocument()"
        (click)="onClickPrevious()"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>
      @if (documentOfDocuments(); as documentOfDocuments) {
        <mat-chip-listbox>
          <mat-chip>{{ documentOfDocuments }}</mat-chip>
        </mat-chip-listbox>
      }
      <button
        mat-icon-button
        [matTooltip]="'NEXT' | transloco"
        [disabled]="!canNavigateToNextDocument()"
        (click)="onClickNext()"
      >
        <mat-icon>arrow_forward</mat-icon>
      </button>
      <span class="spacer"></span>

      <!-- Right side controls -->
      <mat-chip-set>
        <mat-chip [matTooltip]="'UNSAVED_DOCUMENT_MESSAGE' | transloco">{{
          'UNSAVED' | transloco
        }}</mat-chip>
      </mat-chip-set>
      <ngx-compactable-row #compactableRow checkAvailableSpaceAfterViewCheck>
        @if (documentPermissions()?.modifyAnnotations) {
          <ng-template
            ngxCompactableItem
            [priority]="0"
            let-location="location"
            let-priority="priority"
          >
            @if (location === 'menu') {
              <button
                #trigger="matMenuTrigger"
                #item="matMenuItem"
                mat-menu-item
                [matMenuTriggerFor]="annotationsMenu.menu()"
                [attr.data-toolbar-location]="location"
                (mouseenter)="compactableRow.openSubmenu(trigger, item)"
              >
                <mat-icon>drive_file_rename_outline</mat-icon>
                <span transloco="ANNOTATE"></span>
              </button>
              <app-annotation-menu
                #annotationsMenu
                [hideMenuTriggerButton]="true"
                [attr.data-toolbar-location]="location"
              ></app-annotation-menu>
            } @else {
              <app-annotation-menu
                [attr.data-toolbar-location]="location"
              ></app-annotation-menu>
            }
          </ng-template>
        }
        @if (hasNewDocuments()) {
          <ng-template ngxCompactableItem let-location="location">
            @if (location === 'menu') {
              <button
                mat-menu-item
                [attr.data-toolbar-location]="location"
                (click)="onClickOpenNewDocumentsDialog()"
              >
                <mat-icon [matBadge]="newPdfDocumentCount()"> tab </mat-icon>
                <span transloco="OPEN_NEW_DOCUMENTS_DIALOG"></span>
              </button>
            } @else {
              <button
                mat-icon-button
                [attr.data-toolbar-location]="location"
                (click)="onClickOpenNewDocumentsDialog()"
                [matTooltip]="'OPEN_NEW_DOCUMENTS_DIALOG' | transloco"
              >
                <mat-icon [matBadge]="newPdfDocumentCount()">tab</mat-icon>
              </button>
            }
          </ng-template>
        }
        <ng-template ngxCompactableItem let-location="location">
          @if (location === 'menu') {
            <button
              mat-menu-item
              [attr.data-toolbar-location]="location"
              (click)="onClickChangeArchive()"
            >
              <mat-icon>inventory_2</mat-icon>
              <span transloco="CHANGE_ARCHIVE"></span>
            </button>
          } @else {
            <button
              mat-icon-button
              [attr.data-toolbar-location]="location"
              [matTooltip]="'CHANGE_ARCHIVE' | transloco"
              (click)="onClickChangeArchive()"
            >
              <mat-icon>inventory_2</mat-icon>
            </button>
          }
        </ng-template>
        <ng-template
          ngxCompactableItem
          [priority]="5"
          let-location="location"
          let-priority="priority"
        >
          @if (location === 'menu') {
            <button
              mat-menu-item
              [attr.data-toolbar-location]="location"
              [disabled]="disableSave()"
              (click)="onClickSave()"
            >
              <mat-icon>save</mat-icon>
              <span transloco="SAVE"></span>
            </button>
          } @else {
            <button
              mat-icon-button
              [attr.data-toolbar-location]="location"
              [disabled]="disableSave()"
              (click)="onClickSave()"
              [matTooltip]="'SAVE' | transloco"
            >
              <mat-icon>save</mat-icon>
            </button>
          }
        </ng-template>
        <ng-template ngxCompactableItem let-location="location">
          @if (location === 'menu') {
            <button
              mat-menu-item
              [attr.data-toolbar-location]="location"
              [disabled]="isKfiDisabled()"
              (click)="onClickKfiToggle(false)"
            >
              @if (!isKfiActive()) {
                <mat-icon>flash_on</mat-icon>
              }
              <!-- Blue -->
              @if (
                isKfiActive() && !shouldKfiUseLocalOcr() && !shouldKfiForceOcr()
              ) {
                <mat-icon class="active-keyfree-text-layer">flash_on</mat-icon>
              }
              <!-- Yellow -->
              @if (
                (isKfiActive() && shouldKfiForceOcr()) ||
                (isKfiActive() && shouldKfiUseLocalOcr())
              ) {
                <mat-icon class="active-keyfree-ocr">flash_on</mat-icon>
              }
              <span transloco="KEYFREE"></span>
            </button>
          } @else {
            <button
              mat-icon-button
              [attr.data-toolbar-location]="location"
              [disabled]="isKfiDisabled()"
              [matTooltip]="'KEYFREE' | transloco"
              matTooltipPosition="below"
              matTooltipShowDelay="1000"
              (click)="onClickKfiToggle(false)"
            >
              @if (!isKfiActive()) {
                <mat-icon>flash_on</mat-icon>
              }
              <!-- Blue -->
              @if (
                isKfiActive() && !shouldKfiUseLocalOcr() && !shouldKfiForceOcr()
              ) {
                <mat-icon class="active-keyfree-text-layer">flash_on</mat-icon>
              }
              <!-- Yellow -->
              @if (
                (isKfiActive() && shouldKfiForceOcr()) ||
                (isKfiActive() && shouldKfiUseLocalOcr())
              ) {
                <mat-icon class="active-keyfree-ocr">flash_on</mat-icon>
              }
            </button>
          }
        </ng-template>
        @if (isKfiActive() && !shouldKfiUseLocalOcr() && !shouldKfiForceOcr()) {
          <ng-template ngxCompactableItem let-location="location">
            @if (location === 'menu') {
              <button
                mat-menu-item
                [attr.data-toolbar-location]="location"
                [disabled]="isKfiDisabled()"
                (click)="shouldKfiForceOcr.set(true)"
              >
                <mat-icon svgIcon="ocr"></mat-icon>
                <span transloco="KEYFREE"></span>
              </button>
            } @else {
              <button
                mat-icon-button
                [attr.data-toolbar-location]="location"
                [disabled]="isKfiDisabled()"
                [matTooltip]="'KEYFREE' | transloco"
                matTooltipPosition="below"
                matTooltipShowDelay="1000"
                (click)="shouldKfiForceOcr.set(true)"
              >
                <mat-icon svgIcon="ocr"></mat-icon>
              </button>
            }</ng-template
          >"
        }
        <ng-template ngxCompactableItem let-location="location">
          @if (location === 'menu') {
            <button
              mat-menu-item
              [attr.data-toolbar-location]="location"
              (click)="onClickToggleModifyThumbnailer()"
            >
              <mat-icon>edit_note</mat-icon>
              <span transloco="GSG_MODIFY_DOCUMENT"></span>
            </button>
          } @else {
            <button
              mat-icon-button
              [attr.data-toolbar-location]="location"
              [matTooltip]="'GSG_MODIFY_DOCUMENT' | transloco"
              (click)="onClickToggleModifyThumbnailer()"
            >
              <mat-icon>edit_note</mat-icon>
            </button>
          }
        </ng-template>
      </ngx-compactable-row>
      <button
        mat-icon-button
        [matTooltip]="'TOGGLE_INDEXER' | transloco"
        matTooltipShowDelay="1000"
        matTooltipPosition="below"
        (click)="onClickToggleIndexer()"
      >
        <mat-icon>vertical_split</mat-icon>
      </button>
    </mat-toolbar>
    <app-document-view-sidebar
      #rightSidebar
      [archiveId]="document.targetArchiveId"
      [documentSecureId]="''"
      [documentId]="0"
      [viewerPageNumber]="pageNumber()"
      [permissions]="documentPermissions()!"
      [uniqueId]="document.id"
      [fieldValues]="documentFields()"
      (indexerFieldFocused)="onIndexerFieldFocused($event)"
    >
      @if (pdfOptions(); as pdfOptions) {
        <div class="thumbnailer-viewer-container">
          @if (shouldShowModifyThumbnailer()) {
            @if (pdfViewer && !isDocumentLoading()) {
              <app-pdf-thumbnail-viewer
                #thumbnailViewer
                [pdfBytes]="pdfViewer.pdfBytes"
                [thumbnails]="pdfViewer.thumbnails"
                [hasModifyPermissions]="
                  documentPermissions()!.modifyDocuments &&
                  documentPermissions()!.modifyDocumentPages
                "
                [appPdfThumbnailerEventHandler]="thumbnailViewer"
                [appPdfThumbnailerEventHandlerArchiveId]="
                  document.targetArchiveId
                "
                [appPdfThumbnailerHandlerFields]="documentFields()"
                [appPdfThumbnailerEventHandlerViewer]="pdfViewer"
                (pdfModified)="onPdfModified($event)"
              >
              </app-pdf-thumbnail-viewer>
            }
          }
          <div class="viewer-container" [ngStyle]="viewerContainerStyle">
            <app-pdf-viewer
              #pdfViewer
              [pdf-options]="pdfOptions"
              [appKeyfree]="isKfiActive()"
              [appKeyfreeForceOcr]="shouldKfiForceOcr()"
              [appKeyfreeAutoOcr]="shouldKfiAutoOcr()"
              [appKeyfreeIndexer]="rightSidebar.indexer"
              [appKeyfreePdfViewer]="pdfViewer"
              (appKeyfreeLastFieldFilled)="isKfiActive.set(false)"
              (loadFailure)="onLoadFailure()"
              (documentLoadingChange)="onDocumentLoadingChange($event)"
              (pageChange)="onPageChange($event)"
              (afterPrint)="onAfterPrint()"
            ></app-pdf-viewer>
          </div>
        </div>
        @if (showTableFieldGrid()) {
          <app-table-field-grid
            #tableFieldGrid
            [archiveId]="document.targetArchiveId"
            [editModeEnabled]="
              this.documentPermissions()?.addNewDocuments ?? false
            "
          ></app-table-field-grid>
        }
      }
    </app-document-view-sidebar>
  </div>
} @else {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
